import { WatchAccountService } from '../../../services/watch-account.service';
import { AccountService } from '../../../services/account.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { IFunnel, ITag } from '../../../interfaces/graph-types';

export enum STATE {
  ACCCOUNTS = 'accounts',
  PERMISSIONS = 'permissions',
  INVITE = 'invite',
}

@Component({
  selector: 'modal-create-candidate',
  template: require('./modal-create-candidate.component.pug'),
  styles: [require('./modal-create-candidate.component.css').toString()],
})
export class ModalCreateCandidateComponent implements OnInit {
  form: FormGroup;
  keep_creating: boolean;
  error: string = '';
  tags$: Observable<IFunnel[]>;
  public reason: Subject<any>;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    fb: FormBuilder,
    private accountService: AccountService,
    private watchAccount: WatchAccountService,
  ) {
    this.form = fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', Validators.required],
      company: ['', Validators.required],
      title: ['', Validators.required],
      phone: ['', Validators.required],
      role: ['', Validators.required],
      // score: ['', Validators.required],
    });
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.reason = new Subject();
    this.tags$ = this.accountService.tags(
      this.watchAccount.accountId().getValue(),
    );
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  tags = [];

  // -------------------------------------------------------------------
  tagging(tag: ITag, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    tag.value = !tag.value;

    if (tag.value) {
      this.tags.push(tag.id);
    } else {
      let index = this.tags.indexOf(tag.id);
      if (index > -1) {
        this.tags.splice(index, 1);
      }
    }

    onsuccess();
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.accountService.createCandidate(
      this.watchAccount.accountId().getValue(),
      this.getFirstName(),
      this.getLastName(),
      this.getEmail(),
      this.getCompany(),
      this.getTitle(),
      this.getRole(),
      this.getPhone(),
      this.getScore(),
      this.tags,
      res => {
        this.error = res.error;
        if (res.error) {
          onfailure(res.error);
          return;
        }

        if (data) {
          this.reason.next(res.candidateId);
          this.bsModalRef.hide();
          return;
        }
        this.form.reset();
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  getFirstName() {
    return this.form.get('first_name').value;
  }
  getLastName() {
    return this.form.get('last_name').value;
  }
  getEmail() {
    return this.form.get('email').value;
  }
  getCompany() {
    return this.form.get('company').value;
  }
  getTitle() {
    return this.form.get('title').value;
  }
  getRole() {
    return this.form.get('role').value;
  }
  getPhone() {
    return this.form.get('phone').value;
  }
  getScore(): number {
    return 0
    // return +this.form.get('score').value;
  }
}
